jQuery(($) => {

    if ($('.o-thumbnail-description-cards-slider')[0]) {
        $('.o-thumbnail-description-cards-slider').each(function(){

            var dotsNavigation         = $(this).find($('.o-thumbnail-description-cards-slider__dots-navigation')),
                mobileArrowsNavigation = $(this).find($('.o-thumbnail-description-cards-slider__mobile-arrows-navigation')),
                slides                 = $(this).find($('.m-thumbnail-description-cards__list'));
 
            slides.slick({
                speed: 800,
                swipe: true,
                centerMode:true,
                centerPadding: '40.5px',
                cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
                fade: true,
                dots: true,
                appendDots: dotsNavigation,
                responsive: [
                    {
                        breakpoint: 951,
                        settings: {
                        appendArrows: mobileArrowsNavigation
                        },
                    }, 
                ]
            });
        });
    }
});